export const BRANDS_WITH_NEW_INPUTS = [
  "SRP",
  "Victoria Beckham",
  "Intersport",
  "Blackstore",
  "Givenchy",
  "TDF",
  "Etam",
];
